import React, {Component} from 'react';
import {connect} from 'react-redux';

import './style.scss';
import CloseIconComponent from "../../reusable/CloseIconComponent";
import {Dispatch} from "redux";
import {getEventsInfo} from "../../../store/API/actions";
import {ApplicationState} from "../../../store";
import FormHandleEventsComponent from "../../reusable/FormHandleEventsComponent";
import ApplyButtons from "../../reusable/ApplyButtons";
import {triggerAcknowledgeTable} from "../../../store/layouts/actions";
import {doAcknowledgeEvent} from "../../../store/alerts/actions";
import { chooseService } from '../../../utils';
import FormHandleEventCayuga from '../../reusable/FormHandleEventCayuga';

interface IProps {
    dispatch: Dispatch,
    eventsInfo: any
}

interface IState {
    [propName: string] : string
}

class AlertsHandleEventComponent extends Component<any, IState> {
    state = {
        tags: '',
        comments: '',
        classification: '',
        caseName: ''
    };

    onChange = (name: string, value: string) => {
        this.setState({
            [name] : value
        })
    };

    componentDidMount(): void {
        chooseService(
            () => this.props.getEventsInfo(),
            () => {}
        );
    }

    componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any): void {
        if (!this.state.classification && this.props.eventsInfo.classifications.length) {
            this.setState({
                'classification': this.props.eventsInfo.classifications[0].name
            });
        }
    }

    doAcknowledge = () => {
        this.props.closeTable();
        this.props.applyEvents({ ...this.state });
    };


    render() {
        if (!this.props.eventsInfo) return null;
        const { classifications, cases } = this.props.eventsInfo;

        return <div className='acknowledge-form'>
            <div className='acknowledge-form__title'>
                <CloseIconComponent handler={this.props.closeTable}/>
                Handle Event
            </div>
            <div className='acknowledge-form__content'>
                {
                    chooseService(
                        () => {
                            return <>
                                    <FormHandleEventsComponent
                                        onChange={(name: string, string: string) => this.onChange(name, string)}
                                        classification={this.state.classification}
                                        classifications={classifications}
                                        cases={cases}
                                        caseName={''}
                                        tags={this.state.tags}
                                        comments={this.state.comments}
                                    />
                                     <div>
                                        <ApplyButtons
                                            disable={false}
                                            OKHandler={this.doAcknowledge}
                                            cancelHandler={this.props.closeTable}
                                        />
                                    </div>
                                </>
                        },
                        () => <FormHandleEventCayuga
                                confirmHandler={this.props.getEventsInfo} 
                                rejectHandler={this.props.getEventsInfo}
                            />
                    )
                }
            </div>
        </div>
    }
};

const mapDispatchToProps = (dispatch: Dispatch) => {
   return {
       getEventsInfo: (confirm?: boolean) => dispatch(getEventsInfo(confirm && confirm)),
       closeTable: () => dispatch(triggerAcknowledgeTable(false)),
       applyEvents: (eventDescr: any) => dispatch(doAcknowledgeEvent(eventDescr))
   }
};

const mapStateToProps = (state: ApplicationState) => {
    return {
        eventsInfo: chooseService(() => state.API.eventsInfo, () => ({classifications: [], cases: []}))
    }
};

export default connect<any, any, any, any>(mapStateToProps, mapDispatchToProps)(AlertsHandleEventComponent);